import { ActivatedRoute, Router, Scroll, RouterLinkActive, RouterLink } from '@angular/router';
import { UsersService } from '@shared/services/users/users.service';
import { FuseMatchMediaService } from '@fuse/services/match-media.service';
import { DOCUMENT, Location, NgClass, NgTemplateOutlet, AsyncPipe, isPlatformBrowser } from '@angular/common';
import {
  Component,
  OnInit,
  ElementRef,
  ViewEncapsulation,
  ViewChild,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  AfterViewInit,
  HostBinding,
  HostListener,
  Inject,
  Input,
  OnDestroy,
  Optional,
  Renderer2,
  effect,
  signal, PLATFORM_ID,
  inject
} from '@angular/core';
import { Platform } from '@angular/cdk/platform';
import { Observable, Subscription, Subject } from 'rxjs';
import { filter, tap, map, distinctUntilChanged, throttleTime } from 'rxjs/operators';
import { trigger, transition, query, group, state, style, animate, AnimationEvent, AnimationBuilder, AnimationFactory, AnimationPlayer, keyframes, sequence, AnimationMetadata } from '@angular/animations';
import { ICompany } from '@collections/companies/interfaces/company.interface';
import { StandService } from 'app/stand/stand.service';
import { NgScrollbar, ScrollViewport } from 'ngx-scrollbar';
import { ScrollBarService } from '@shared/scroll/scrollbar.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { IconsLoader } from 'app/shared/services/icons/icons-loader.service';
import { AccountType } from '@collections/companies/enums';
import { LabelValue } from 'app/shared/constants/labelValue.model';
import { FieldsOfRelevanceEnum } from '@collections/common/enums/fields-of-relevance.enums';
import { FieldsOfRelevances } from 'app/shared/constants/fields-of-relevance';
import { getAnimationSteps, IAnimationStepsInfo } from 'app/shared/animations/utilities';
import { AnalyticsService } from 'app/shared/services/google-tag-manager/analytics/analytics.service';
import { GetStandVideoUrlPipe } from './get-stand-video-url.pipe';
import { GetMaterialsTypePipe } from './get-materials-label.pipe';
import { GetCountryNamePipe } from '../../../shared/pipes/get-country-name.pipe';
import { GetCompanyUrlPipe } from '../../../shared/pipes/get-company-url.pipe';
import { MatTabNav, MatTabLink, MatTabNavPanel } from '@angular/material/tabs';
import { FlagComponent } from '../../../shared/components/flag/flag.component';
import { CldPictureComponent } from '../../../shared/components/cld-picture/cld-picture.component';
import { MatButton, MatIconButton } from '@angular/material/button';
import { ExpoButtonComponent } from '../../../shared/components/expo-button/expo-button.component';
import { MatRipple } from '@angular/material/core';
import { MatTooltip } from '@angular/material/tooltip';
import { MatIcon } from '@angular/material/icon';
import { RenderIfDirective } from '../../../shared/directives/render-if.directive';
import { BreadcrumbComponent } from '../../../shared/components/breadcrumb/breadcrumb.component';
import { HTMLContentComponent } from 'app/shared/components/html-content/html-content.component';
import { DataSharingService } from '../data-sharing.service';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
@UntilDestroy()
@Component({
    selector: 'stand-header',
    templateUrl: './stand-header.component.html',
    styleUrls: ['./stand-header.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    animations: [
        trigger('readMoreTextUp', [
            state('false', style({
                transform: 'translateY(0)'
            })),
            state('true', style({
                transform: 'translateY(-20px)'
            })),
            transition('false => true', [
                animate('250ms ease-in')
            ]),
            transition('true => false', [
                animate('250ms ease-out')
            ])
        ]),
        trigger('readMoreArrowShow', [
            transition(':enter', [
                style({ opacity: 0 }),
                animate('0.5s ease-in', style({ transform: 'translateY(0)', opacity: 1 }))
            ]),
            transition(':leave', [
                animate('300ms ease-out', style({ transform: 'translateY(20px)', opacity: 0 }))
            ])
        ]),
        trigger('headerAnim', [
            transition('expanded => description-expanded', [
                group([
                    query('.ct', [style({ overflow: 'visible' })]),
                    // sposta verso l'alto il pulsante play
                    query('.play-button', [
                        animate('300ms ease-in', style({ transform: 'translateY(-5vh)', opacity: 0 }))
                    ], { optional: true }),
                    // sposta sotto il logo le informazioni
                    query('.additional-info', [
                        animate('300ms ease-out', style({ transform: 'translate(var(--ad-info-tx), var(--ad-info-ty))' }))
                    ]),
                    query('.company-name', [
                        animate('300ms ease-out', style({ transform: 'translateY(var(--e-cname-t)' }))
                    ]),
                    query('.company-logo', [
                        animate('300ms ease-out', style({ transform: 'translateY(var(--e-logo-t)' }))
                    ]),
                    // aumenta altezza top header
                    query('.backgrounds-ct', [
                        animate('300ms ease-out', style({ transform: 'scale(calc(var(--vh) * var(--e-top-cont-hn) / var(--top-cont-hn)))' }))
                    ]),
                    query('.description-ct', [
                        animate('300ms ease-out', style({ transform: 'translateY(calc(var(--e-top-cont-h) - var(--top-cont-h)))', paddingTop: '10px' }))
                    ]),
                    query('.navigation-bar', [
                        animate('300ms ease-out', style({ transform: 'translate(var(--navbar-tx), calc(var(--e-top-cont-h) - var(--top-cont-h)))' }))
                    ]),
                ]),
                query('.description-ct', [
                    animate('100ms ease-out', style({ height: 'var(--e-description-h)', width: 'var(--e-description-w)' }))
                ])
            ]),
            transition('description-expanded => expanded', [
                query('.description-ct', [
                    style({ height: 'var(--description-h)', width: 'var(--description-w)' })
                ]),
                group([
                    // sposta verso il basso il pulsante play
                    query('.play-button', [
                        animate('300ms ease-out', style({ transform: 'translateY(0)', opacity: 1 }))
                    ], { optional: true }),
                    // sposta a destra del logo le informazioni
                    query('.additional-info', [
                        animate('300ms ease-out', style({ transform: 'translate(0, 0)' }))
                    ]),
                    query('.company-name', [
                        animate('300ms ease-out', style({ transform: 'translateY(0)' }))
                    ]),
                    query('.company-logo', [
                        animate('300ms ease-out', style({ transform: 'translateY(0)' }))
                    ]),
                    // riduce altezza top header
                    query('.backgrounds-ct, .description-ct', [
                        animate('300ms ease-out', style({ transform: 'scale(1) translateY(0)' }))
                    ]),
                    query('.navigation-bar', [
                        animate('300ms ease-out', style({ transform: 'translate(var(--navbar-tx), 0)' }))
                    ]),
                ]),
                query('.ct', [style({ overflow: 'hidden' })]),
            ]),
            transition('slide => void', [
                // Create a sequence of animations.
                query(':self', [style({}), animate(800, style({}))], {
                    optional: true
                })
            ])
        ])
    ],
    standalone: true,
    imports: [BreadcrumbComponent, NgClass, RenderIfDirective, NgTemplateOutlet, MatIcon, MatTooltip, MatRipple, ExpoButtonComponent, MatButton, CldPictureComponent, FlagComponent, ScrollViewport, NgScrollbar, MatIconButton, MatTabNav, MatTabLink, RouterLinkActive, RouterLink, MatTabNavPanel, AsyncPipe, GetCompanyUrlPipe, GetCountryNamePipe, GetStandVideoUrlPipe, GetMaterialsTypePipe, HTMLContentComponent]
})
export class StandHeaderComponent implements OnInit, AfterViewInit, OnDestroy {

  $company: Observable<ICompany>;
  standImg: string;
  showFullScreenVideo = false;
  headerIsCollapsed = false;
  animationRunning = false;
  editPath: string;
  isEditing = false;
  hideNavBar = false;
  showOverlay: boolean = false;
  overlayVisible: boolean;
  tourStep: number = 1;
  isMobile: boolean = false;

  scrollBar: NgScrollbar;
  lastScroll: number;
  oldScroll: number;
  wheelEv: Observable<WheelEvent>;

  companyNameHeaderTag = true;

  @Input() categoryPath: string;

  accountType = AccountType;

  @ViewChild('descScrollbar', { static: false }) descScrollbar: NgScrollbar;
  @ViewChild('descriptionTextCt', { static: true }) descriptionTextCt: ElementRef;
  @ViewChild('headerVideo', { static: false }) headerVideo: ElementRef;

  @HostBinding('@headerAnim')
  get headerState(): string {
    return this._headerState;
  }
  set headerState(v: string) {
    this._headerState = v;
  }
  private _headerState =  'expanded';

  get collapsed(): boolean {
    return this._collapsed;
  }
  set collapsed(v: boolean) {
    this._collapsed = v;
  }
  private _collapsed: boolean;
  private collapseFactory: AnimationFactory;
  private expandFactory: AnimationFactory;

  private currAnimPlayer: AnimationPlayer;
  private lastAnimPlayer: AnimationPlayer;

  private wheelEvent = 'onwheel' in this.document.createElement('div') ? 'wheel' : 'mousewheel';
  private wheelOpt = { passive: false };

  private preventDefault = (e: Event): void => {
    e.preventDefault();
  };

  private preventDefaultForScrollKeys = (e: KeyboardEvent): void => {
    const keys = [37, 38, 39, 40]; // Arrow keys
    if (keys.includes(e.keyCode)) {
      e.preventDefault();
    }
  };


  @HostBinding('class.decription-expanded')
  get isDecriptionExpanded(): boolean {
    return this.descriptionExpanded;
  }

  isLoggedIn = false;
  descriptionHover = false;

  descriptionExpanded = false;
  private sbmSubscription: Subscription;
  private isAnimating = false;
  private onAnimationEnd = new Subject();
  fieldsOfInterest: LabelValue<FieldsOfRelevanceEnum>[] = FieldsOfRelevances;

  private needWorkaround = false;
  isFollowedCompany = false;
  company = signal<ICompany>(null);
  selectedOption: string | null = null;


  constructor(
    public el: ElementRef,
    private platform: Platform,
    private location: Location,
    private cd: ChangeDetectorRef,
    private scrollBarService: ScrollBarService,
    public standService: StandService,
    private matchMediaService: FuseMatchMediaService,
    private iconsLoader: IconsLoader,
    public usersService: UsersService,
    @Inject('FALLBACK_COMPANY_IMAGE') public companyFallbackImage: string,
    @Inject('ISTTOUCH') public isTouch: boolean,
    private builder: AnimationBuilder,
    @Optional() public analyticsService: AnalyticsService,
    public activatedRoute: ActivatedRoute,
    private renderer: Renderer2,
    @Inject(DOCUMENT) private document: Document,
    @Inject(PLATFORM_ID) private platformId: object,
    private dataSharing: DataSharingService,
    private breakpointObserver: BreakpointObserver
  ) {
    this.lastScroll = 0;
    this.collapsed = false;
    this.dataSharing.overlayVisible$.subscribe(isVisible=> {
      this.overlayVisible = isVisible;
    })
    this.iconsLoader.load('sectors');
    this.iconsLoader.load('tour');

    effect(() => {
      const options = this.standService.standLayout();
      if(options) {
        if (options.customH1Tag) {
          this.companyNameHeaderTag = false;
        }
        else {
          this.companyNameHeaderTag = true;
        }
  
        if (options.collapse) {
          if (options.animate) {
            this.toogleCollapse(true);
          }
        }
        this.hideNavBar = options.hideNavBar;
  
        if (this.platform.isBrowser) {
  
          if (this.sbmSubscription) {
            this.sbmSubscription.unsubscribe();
            this.sbmSubscription = null;
          }
          if (!options.lockCollapsed) {
            this.scrollBar = this.scrollBarService.mainScrollbar;
            this.sbmSubscription = this.scrollBarService.monitorScrollTop(this.scrollBar, true)
            .pipe(
              tap(() => this.descriptionExpanded ? this.toogleDescription() : null),
              filter(() => !this.descriptionExpanded),
              map(([prev, curr]) => curr > 0),
              distinctUntilChanged(),
              tap(() => {
                if (this.isAnimating && this.currAnimPlayer.hasStarted()) {
                  this.currAnimPlayer.reset();
                }
              }),
              untilDestroyed(this)
            )
            .subscribe((collapse) => {
              this.toogleCollapse(collapse);
            });
  
            if (this.collapsed) {
              this.scrollBar.scrollTo({top: 5, duration: 0});
            } else {
              this.scrollBar.scrollTo({top: 0, duration: 0});
            }
  
            this.onAnimationEnd
            .pipe(
              throttleTime(10),
              distinctUntilChanged((prev: any, curr: any) => prev.toState === curr.toState),
              untilDestroyed(this)
            )
            .subscribe((event: any) => {
              if (event.toState === 'description-expanded') {
                this.descriptionExpanded = true;
              } else if (event.fromState === 'description-expanded') {
                this.descriptionExpanded = false;
                this.descScrollbar.scrollTo({top: 0, duration: 0 });
              }
              this.cd.markForCheck();
            });
          }
        }
      }
    })
  }

  ngOnInit(): void {
    this.breakpointObserver.observe([Breakpoints.Handset]).subscribe(result => {
      this.isMobile = result.matches;
    });
    if(!this.isMobile){
    }
    this.$company = this.standService.getCurrentCompany();
    if(isPlatformBrowser(this.platformId)){
    const overlaySeen = localStorage.getItem('overlaySeen');
    if(overlaySeen) {
      this.showOverlay = false;
    } else {
      this.showOverlay = true;
    }
  }

  this.$company.pipe(
      untilDestroyed(this)
    ).subscribe((company) => {
      this.company.set(company);

      let bgStyle = null;
      const videoUrlPipe = new GetStandVideoUrlPipe();

      const videoBg: any[] = [
        {
          media: '(min-width: 481px)',
          url:  videoUrlPipe.transform(company.video ,'header','jpg', 'md', 40)
        },
        {
          media: '(max-width: 480px)',
          url:  videoUrlPipe.transform(company.video ,'header','jpg', 'xs', 20)
        }
      ]
      
      const styles = 
      ".header-video-bg {" +
        "background-image: url('"+ videoBg[0].url +"');" +
      "}" +
      "@media screen and (max-width: 479px) {" +
        ".header-video-bg {" +
          "background-image: url('"+ videoBg[1].url +"');" +
        "}" +
      "}";

      bgStyle = this.renderer.createElement('style');
      bgStyle.id = 'videoBgImage';
      if (bgStyle.styleSheet) {
          bgStyle.styleSheet.cssText = styles;
      }
      else {
        this.renderer.appendChild(bgStyle, this.document.createTextNode(styles));
      }

      this.renderer.appendChild(this.el.nativeElement, bgStyle);

      if(!this.platform.isBrowser) {
        videoBg.forEach( v => {
          const link = this.renderer.createElement('link');
          this.renderer.setAttribute(link, 'class', 'bg-video-pre');
          this.renderer.setAttribute(link, 'rel', 'prefetch');
          this.renderer.setAttribute(link, 'as', 'image');
          this.renderer.setAttribute(link, 'href', v.url);
          this.renderer.setAttribute(link, 'media', v.media);
          this.renderer.appendChild(this.document.head, link);
        });
      } else {
        const preLinks = document.getElementsByClassName('bg-video-pre') || [];
        setTimeout(() => {
          while(preLinks.length > 0){
            console.log('link removed')
            preLinks[0].parentNode.removeChild(preLinks[0]);
          }
        }, 2000);
      }

      
      if (this.platform.isBrowser) {
        this.usersService.onUserChange
        .pipe(
          untilDestroyed(this)
        ).subscribe(async (user) => {
          this.isLoggedIn = !!user;
          this.isFollowedCompany = this.usersService.isFollowedCompany(this.company()._id);
        });
      }
    });

    if (this.platform.isBrowser && this.platform.SAFARI) {
      const regex = new RegExp('(?:Version\/([0-9]{2})).([0-9]{1})|(?:(?:iPhone|CPU) OS ([0-9]{2})_([0-9]{1}))','gi');

      const groups = regex.exec(navigator.userAgent);
      if (groups) {
        const ver = Number(groups.reduce((p, c) => p.concat(Number(c) ? c : ''), ''));
        this.needWorkaround = ver ? ver < 154 : true;
      }
    }

    this.standService.$onSlideStand
    .pipe(
      untilDestroyed(this)
    )
    .subscribe((opt: any) => {
      this.headerState = 'slide';
      this.cd.markForCheck();
    });


  }

  toggleFollowedCompany(): void {
    this.usersService.toggleFollowCompany(this.company(), () => this.cd.detectChanges());
  }

  ngAfterViewInit(): void {
    if (this.platform.isBrowser) {
      this.collapsed = false;
    }
  }

  @HostListener('@headerAnim.done', ['$event'])
  headerAnimationDone(event: AnimationEvent): void {
    this.isAnimating = false;
    if (event.fromState == 'void' || event.toState == 'void') {
      return;
    }
    this.onAnimationEnd.next(event);
  }

  toogleDescription(): void {
    if (this.lastAnimPlayer) {
      this.lastAnimPlayer.destroy();
      this.lastAnimPlayer = null;
    }
    this.standService.$onDescriptionExpanded.next(!this.descriptionExpanded);
    // this.scrollBar.disabled = this.descriptionExpanded;
    this.headerState = this.descriptionExpanded ? 'expanded' : 'description-expanded';
  }

  toogleCollapse(collapse: boolean): void {

    if (this.collapsed  === collapse) {
      return;
    }
    const sbEl = this.scrollBar.viewport.nativeElement
    const scrollEventHandler =  () => {
      sbEl.scrollTop = 2;
    };

    if (collapse) {
      this.scrollBarService.setSmoothScroll({stepSize: 0});
      sbEl.addEventListener('scroll', scrollEventHandler);
    }

    this.collapseFactory = this.getAnimationFactory(false);
    this.expandFactory = this.getAnimationFactory(true);
    this.isAnimating = true;
    this.standService.$onHeaderStateChange.next(collapse);
    const el = document.querySelector('app');
    const player = collapse ? this.collapseFactory.create(el) : this.expandFactory.create(el);

    player.onDone(async () => {
      if (collapse) {
        this.scrollBarService.setSmoothScroll();
        sbEl.removeEventListener('scroll', scrollEventHandler);
      }


      const _player = this.lastAnimPlayer;
      this.lastAnimPlayer = _player ? (() => { _player.destroy(); return player; })()  : player;
      this.collapsed = collapse;
      const sb = this.scrollBar;
      this.isAnimating = false;

      this.cd.markForCheck();
    });

    this.currAnimPlayer = player;
    player.play();
  }

  getAnimationFactory(reverse: boolean = false): AnimationFactory {
    let steps: IAnimationStepsInfo[];

    switch (this.matchMediaService.screen()) {
      case 'md':
        steps = [
          { from: 0, to: -230, type: 't', key: 'ctTY' },
          { from: 0, to: 110, type: 't', key: 'thTX' },
          { from: 0, to: 0, type: 't', key: 'twTX' },
          { from: 0, to: 225, type: 't', key: 'twTY' },
          { from: 0, to: 230, type: 't', key: 'bcTY' },
          { from: 120, to: 50, type: 's', key: 'logoS' },
          { from: 0, to: 10, type: 't', key: 'logoTX' },
          { from: 0, to: 10, type: 't', key: 'logoTY' },
          { from: 0, to: 125, type: 't', key: 'cnTY' },
          { from: 0, to: 70, type: 't', key: 'cnTX' },
          { from: 0, to: 0, type: 't', key: 'barTX' },
          { from: 100, to: 100, type: 't', key: 'barMaxW' }
        ];
        break;
      case 'lg':
        steps = [
          { from: 0, to: -230, type: 't', key: 'ctTY' },
          { from: 0, to: 100, type: 't', key: 'thTX' },
          { from: 0, to: -100, type: 't', key: 'twTX' },
          { from: 0, to: 225, type: 't', key: 'twTY' },
          { from: 0, to: 230, type: 't', key: 'bcTY' },
          { from: 120, to: 50, type: 's', key: 'logoS' }, // 53 / (70 / 300) = misura / (altezza scaleY / larghezza)
          { from: 0, to: 10, type: 't', key: 'logoTX' },
          { from: 0, to: 10, type: 't', key: 'logoTY' }, // 250 * 2 - ( 70 - 50 )     transform: scale(0.25) translateY(960px);
          { from: 0, to: 134, type: 't', key: 'cnTY' },
          { from: 0, to: 70, type: 't', key: 'cnTX' },
          { from: 0, to: 50, type: 't', key: 'barTX' },
          { from: window.screen.width, to: 1590, type: 't', key: 'barMaxW' }
        ];
        break;
      case 'xl':
      case '2xl':
        steps = [
          { from: 0, to: -230, type: 't', key: 'ctTY' },
          { from: 0, to: 100, type: 't', key: 'thTX' },
          { from: 0, to: -100, type: 't', key: 'twTX' },
          { from: 0, to: 225, type: 't', key: 'twTY' },
          { from: 0, to: 230, type: 't', key: 'bcTY' },
          { from: 200, to: 50, type: 's', key: 'logoS' }, // 53 / (70 / 300) = misura / (altezza scaleY / larghezza)
          { from: 0, to: -180, type: 't', key: 'logoTX' },
          { from: 0, to: -230, type: 't', key: 'logoTY' }, // 250 * 2 - ( 70 - 50 )     transform: scale(0.25) translateY(960px);
          { from: 0, to: 153, type: 't', key: 'cnTY' },
          { from: 0, to: 20, type: 't', key: 'cnTX' },
          { from: 0, to: 56, type: 't', key: 'barTX' },
          { from: window.screen.width, to: 1590, type: 't', key: 'barMaxW' }
        ];
        break;

      default:
        steps = [
          { from: 0, to: -230, type: 't', key: 'ctTY' },
          { from: 0, to: 0, type: 't', key: 'thTX' },
          { from: 0, to: 0, type: 't', key: 'twTX' },
          { from: 0, to: 0, type: 't', key: 'twTY' },
          { from: 0, to: 230, type: 't', key: 'bcTY' },
          { from: 120, to: 50, type: 's', key: 'logoS' }, // 53 / (70 / 300) = misura / (altezza scaleY / larghezza)
          { from: 0, to: 10, type: 't', key: 'logoTX' },
          { from: 0, to: 294, type: 't', key: 'logoTY' },
          { from: 0, to: 244, type: 't', key: 'cnTY' },
          { from: 0, to: 70, type: 't', key: 'cnTX' },
          { from: 0, to: 0, type: 't', key: 'barTX' },
          { from: 0, to: 0, type: 't', key: 'barMaxW' }
        ];
    }
    let _keyframes = 100;
    if (this.platform.FIREFOX) {
      _keyframes = 5;
    }
    const anim = getAnimationSteps(steps, reverse, _keyframes);

    const barLinkTranslate = reverse ? '0' : 'calc((100vw - var(--container)) / 2)';
    const bgPos = reverse ? 'top' : 'bottom';
    const opacity = reverse ? 1 : 0;

    const curve = reverse ? 'ease-out' : 'ease-in';
    // const curve = 'linear';
    // const delay = reverse ? '50ms' : '';
    const time = '300ms';
    const logoTime = reverse ? '300ms' : '210ms';
    const logoCurve = reverse ? 'ease-in' : 'ease';

    const animGroup: AnimationMetadata[] = [
      // diminuisce altezza top header
      query('#mainContent, #standFooter',
        animate(`${time} ${curve}`,
          keyframes(anim.map((a) => style({
            transform: `translate3d(0px, ${a.get('ctTY').inverse}px, 0px)`,
          })
          )))
      ),
      query('#standFooter', [
        animate(`${time} ${curve}`, style({ opacity: reverse ? 0 : 1 }))
      ]),
      query('.play-button, .description-ct, .additional-info', [
        animate(`${time} ${curve}`, style({ opacity: opacity }))
      ]),
      query('.top-header-content',
        animate(`${time} ${curve}`,
          keyframes(anim.map((a) => style({
            transform: `translate3d(${a.get('thTX').inverse}%, ${a.get('twTY').inverse}px, 0px)`,
          })
          )))
        , { optional: true }),
      query('.top-data-wrapper',
        animate(`${time} ${curve}`,
          keyframes(anim.map((a) => style({
            transform: `translateX(${a.get('twTX').inverse}%)`,
            transformOrigin: 'bottom left'
          })
          )))
        , { optional: true }),
      query('.breadcrumbs',
        animate(`${time} ${curve}`,
          keyframes(anim.map((a) => style({
            transform: `translateY(${a.get('bcTY').inverse}px)`
          })
          )))),

      query('.company-name',
        animate(`${time} ${curve}`,
          keyframes(anim.map((a) => style({
            transform: `translate(${a.get('cnTX').inverse}px, ${a.get('cnTY').inverse}px)`,
          }))
          ))),
      //   // imposto a bianco il colore testo del nome azienda
      query('.company-logo', [
        animate(`${logoTime} ${logoCurve}`,
          keyframes(anim.map((a) => style({
            transform: `scale(${a.get('logoS').step})
            translate(${a.get('logoTX').inverse}px, ${a.get('logoTY').inverse}px)`,
            transformOrigin: 'bottom left'
          }))
          ))
      ]),
      query('.navigation-bar',
        animate(`${time} ${curve}`,
          keyframes(anim.map((a) => style({
            transform: `translateX(${a.get('barTX').step}%)`,
          })))
        ), { optional: true }),
      query('.mat-mdc-tab-link-container',
        animate(`${time} ${curve}`, style({ transform: `translateX(${barLinkTranslate})` }))
        , { optional: true })
    ];

    if (this.needWorkaround) {
      animGroup.splice(1, 0,
        query('stand-header',
          animate(`${time} ${curve}`,
            keyframes(anim.map((a) => style({
              top: `${(a.get('ctTY').inverse + 64)}px`,
            })
          )))
        ),
        query('info-bar .stand-info-bar',
          animate(`${time} ${curve}`,
            keyframes(anim.map((a) => style({
              top: `${(450 + a.get('ctTY').inverse)}px`,
            })
          ))), { optional: true}
        )
      )
    }

    return this.builder
      .build([
        sequence([
          group([
            query('.description-ct', [
              style({ display: 'block' })
            ], { optional: true }),
            query('.top-header-container', [
              style({ zIndex: reverse ? 'unset' : -1 })
            ]),
          ]),
          group(animGroup)
          , query('.description-ct', [
            style({ display: reverse ? 'block' : 'none' })
          ], { optional: true })
        ])
      ]);
  }

  descriptionEnter(): void {
    this.descriptionHover = true;
  }

  descriptionLeave(): void {
    this.descriptionHover = false;
  }

  goBack(): void {
    this.location.back();
  }

  openFullscreen(): void {
    const video: any = this.headerVideo.nativeElement;
    if (!this.showFullScreenVideo) {
      video.pause();
      this.showFullScreenVideo = true;
      video.load();
    }

    video.currentTime = 0;
    if (video.requestFullscreen) {
      video.requestFullscreen();
    } else if (video.webkitRequestFullscreen) { /* Safari */
      video.webkitRequestFullscreen();
    } else if (video.msRequestFullscreen) { /* IE11 */
      video.msRequestFullscreen();
    }
  }

  changeVideoSource(video): void {
    if (!document.fullscreenElement) {
      this.showFullScreenVideo = false;
    }
    video.muted = !video.muted;
  }

  onPanUp(e): void {
    if (e.pointerType === 'touch' && !this.collapsed) {
      this.scrollBar.scrollTo({top: e.distance});
      this.cd.detectChanges();
    }
  }

  onPanDown(e): void {
    if (e.pointerType === 'touch' && this.collapsed) {
      this.scrollBar.scrollTo({top: 0});
      this.cd.detectChanges();
    }
  }

  ngOnDestroy(): void {
    if (this.lastAnimPlayer) {
      this.lastAnimPlayer.destroy();
    }
  }

  navigateNextStand(e): void {
    if (e.angle < 100) {
      return;
    }
    this.standService.navigateNextStand();
  }

  nextStep(): void {
    this.tourStep++;
    if (this.tourStep >= 4){
      if (isPlatformBrowser(this.platformId)){
        localStorage.setItem('overlaySeen', 'true');
        this.showOverlay = false;
        this.dataSharing.setOverlayVisible(true)
      }
    }
    else if (this.tourStep == 3)
      this.dataSharing.setOverlayVisible(false);
    else
      this.dataSharing.setOverlayVisible(true);
  }
  
}